import BaseApi from './BaseApi';

import { StatementData } from 'models';

class StatementApi extends BaseApi {
	constructor() {
		super('/investor/statement');
	}

	getOtherUrl({ from, to, interval }: StatementData) {
		return `/${from}/${to}/${interval}`;
	}

	getInterest(data: StatementData) {
		return this.httpClient.get({
			url: `/interest${this.getOtherUrl(data)}`,
			conditions: { version: 'v2', auth: true },
		});
	}

	getSecondaryMarketIncome(data: StatementData) {
		return this.httpClient.get({
			url: `/secondary-market/income${this.getOtherUrl(data)}`,
			conditions: { version: 'v2', auth: true },
		});
	}

	getInvestment(data: StatementData) {
		return this.httpClient.get({
			url: `/investment${this.getOtherUrl(data)}`,
			conditions: { version: 'v2', auth: true },
		});
	}
	getPrincipalRepayment(data: StatementData) {
		return this.httpClient.get({
			url: `/principal-repayment${this.getOtherUrl(data)}`,
			conditions: { version: 'v2', auth: true },
		});
	}
	getDepositWithdrawal(data: StatementData) {
		return this.httpClient.get({
			url: `/deposit-withdrawal${this.getOtherUrl(data)}`,
			conditions: { version: 'v2', auth: true },
		});
	}
}

export const StatementService = new StatementApi();
